// extracted by mini-css-extract-plugin
export default {"InputV2":"inputV2_InputV2__JqHmv","InputV2Wrapper":"inputV2_InputV2Wrapper__YPrsG","InputV2Label":"inputV2_InputV2Label__8icti"};